<template>
  <b-container>
    <h1 v-translate>New Quote</h1>
    <quotes-create />
  </b-container>
</template>

<script>
import QuotesCreate from '@/components/QuotesCreate'
export default {
  components: {
    QuotesCreate
  }
}
</script>
